<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'apps-users-list'}">
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs vertical content-class="col-12 col-md-10 mt-0 mt-md-0" nav-class="nav-left"
            nav-wrapper-class="col-12 col-md-2 border rounded p-1" v-if="userData" pills>

      <!-- Tab: information -->
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
        </template>
        <user-edit-tab-information
          :user-data="userData"
          class="mt-0 "
        />
      </b-tab>

      <!-- Tab: permissions -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="KeyIcon" size="16" class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Permissions') }}</span>
        </template>
        <user-edit-tab-permission :user="userData.id" class="mt-0" />
      </b-tab>

      <div v-if="$store.state.auth.userData.roles.includes(this.$roles.SUPER_ADMIN)">

      <b-tab lazy>
        <template #title>
          <feather-icon icon="KeyIcon" size="16" class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Wasl') }}</span>
        </template>

        <user-edit-tab-wasl :userData="userData" class="mt-0" />
      </b-tab>

      </div>

    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BFormInput, BFormGroup, BCol, BRow,
} from 'bootstrap-vue'
import { ref, onUnmounted, watch } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import userStoreModule from '../userStoreModule'
import UserEditTabInformation from './UserEditTabInformation.vue'
import UserEditTabPermission from './UserEditTabPermission.vue'
import UserEditTabWasl from  './UserEditTabWasl.vue'
import { OrbitSpinner } from 'epic-spinners'
import useUserEdit from '@/views/modules/user/users-edit/useUserEdit'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BAlert,
    OrbitSpinner,
    BLink,

    UserEditTabInformation,
    UserEditTabPermission,
    UserEditTabWasl
  },
  setup() {

    const userData = ref(null)

    const USER_ = 'appUser'

    if (!store.hasModule(USER_)) store.registerModule(USER_, userStoreModule)
    onUnmounted(() => {
      if (store.hasModule(USER_)) store.unregisterModule(USER_)
    })

    store.dispatch('appUser/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        userData.value = response.data
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    return {
      userData
    }
  },
}
</script>

<style>

</style>
